import moment from 'moment';

import { TTariffProfile } from '../../../core/tariff-profile';
import { TTariffProfileDateType, TTariffProfileMetaFormFields } from './types';

const detectDateType = (tariffProfile: TTariffProfile) => {
  let dateType: TTariffProfileDateType = 'always';
  const hasPayDate = [
    !!tariffProfile.fromPayDate,
    !!tariffProfile.toPayDate,
  ].some(Boolean);

  const hasTripDate = [
    !!tariffProfile.fromTripDate,
    !!tariffProfile.toTripDate,
  ].some(Boolean);

  if (hasPayDate) {
    dateType = 'payDate';
  }

  if (hasTripDate) {
    dateType = 'tripDate';
  }

  return dateType;
};

export const extractMetaFormFields = (tariffProfile: TTariffProfile) => {
  const result: TTariffProfileMetaFormFields = {
    name: tariffProfile.name,
    trainType: tariffProfile.trainType,
    dateType: detectDateType(tariffProfile),
    dateFrom: undefined,
    dateTo: undefined,
  };

  if (result.dateType === 'tripDate') {
    result.dateFrom = tariffProfile.fromTripDate
      ? moment(tariffProfile.fromTripDate)
      : undefined;
    result.dateTo = tariffProfile.toTripDate
      ? moment(tariffProfile.toTripDate)
      : undefined;
  }

  if (result.dateType === 'payDate') {
    result.dateFrom = tariffProfile.fromPayDate
      ? moment(tariffProfile.fromPayDate)
      : undefined;
    result.dateTo = tariffProfile.toPayDate
      ? moment(tariffProfile.toPayDate)
      : undefined;
  }

  return result;
};
